import { render, staticRenderFns } from "./DistributorProducts.vue?vue&type=template&id=572660ec"
import script from "./DistributorProducts.vue?vue&type=script&lang=js"
export * from "./DistributorProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports